module.exports = __webpack_public_path__ + "static/img/sport-issue-popular-search-slide.0b42838.jpg";